import { EntityModel } from '@/interfaces'
import {
  ALL_MANDATORY_SETTINGS_QUERY,
  CREATE_MANDATORY_SETTINGS_MUTATION,
  DELETE_MANDATORY_SETTINGS_MUTATION,
  FORCE_DELETE_MANDATORY_SETTINGS_MUTATION,
  SINGLE_MANDATORY_SETTINGS_QUERY,
  UPDATE_MANDATORY_SETTINGS_MUTATION,
} from './graphql'
import travelPricingRulesEntity from '@/entities/travelPricingRules/entity'
import travelServiceDateSwitchSettingsEntity from '@/entities/travelServiceDateSwitchSettings/entity'
import travelServiceBusSettingsEntity from '@/entities/travelServiceBusSettings/entity'

const travelPricingMandatorySettingsModel: EntityModel = {
  name: 'mandatorySettings',
  namePlural: 'mandatorySettings',
  uniqueName: 'travelPricingMandatorySettings',
  uniqueNamePlural: 'travelPricingMandatorySettings',
  path: 'travel/pricing/mandatory_settings',
  baseUrl: '/travel/pricing/mandatory_settings',
  translationPrefix: 'entities:travelPricingMandatorySettings.',
  getDisplayName: (values: any) => {
    return 'Mandatory Settings'
  },
  gql: {
    getAll: ALL_MANDATORY_SETTINGS_QUERY,
    getSingle: SINGLE_MANDATORY_SETTINGS_QUERY,
    create: CREATE_MANDATORY_SETTINGS_MUTATION,
    update: UPDATE_MANDATORY_SETTINGS_MUTATION,
    delete: DELETE_MANDATORY_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_MANDATORY_SETTINGS_MUTATION,
  },
  attributes: {
    isMandatory: {
      name: 'isMandatory',
      label: 'entities:travelPricingMandatorySettings.attributes.isMandatory.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    useRules: {
      name: 'useRules',
      label: 'entities:travelPricingMandatorySettings.attributes.useRules.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    rules: {
      name: 'rules',
      label: 'entities:travelPricingMandatorySettings.attributes.rules.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelPricingRulesEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    useDateSwitch: {
      name: 'useDateSwitch',
      label: 'entities:travelPricingMandatorySettings.attributes.useDateSwitch.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    dateSwitchSettings: {
      name: 'dateSwitchSettings',
      label: 'entities:travelPricingMandatorySettings.attributes.dateSwitchSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelServiceDateSwitchSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    useBusSettings: {
      name: 'useBusSettings',
      label: 'entities:travelPricingMandatorySettings.attributes.useBusSettings.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    busSettings: {
      name: 'busSettings',
      label: 'entities:travelPricingMandatorySettings.attributes.busSettings.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelServiceBusSettingsEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPricingMandatorySettingsModel
